function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs12"
}, /*#__PURE__*/React.createElement("style", {
  id: "style10"
}, "{\".cls-2{fill:#003168}\"}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "path16",
  transform: "translate(-13.49 -8.85)",
  d: "M195.26 8.85h-38.21a4.49 4.49 0 00-4.56 4.39v26.33a4.49 4.49 0 004.56 4.43h38.21a4.49 4.49 0 004.56-4.39V13.24a4.49 4.49 0 00-4.56-4.39z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path18",
  className: "cls-2",
  transform: "translate(-13.49 -8.85)",
  d: "M182.91 14.06h-12.28a1 1 0 00-1 1v22.66a1 1 0 001 1h11.58c11.5 0 12.42-9 12.42-11.52v-1.9c-.4-9.89-8.46-11.24-11.72-11.24zM181.08 32h-3.64V20.85h3.78s5.31-.4 5.31 5.43a5.35 5.35 0 01-5.45 5.72z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "path20",
  transform: "translate(-13.49 -8.85)",
  d: "M166.78 19.81v-4.74a1 1 0 00-1-1H160a1 1 0 00-1 1v7.87z",
  fill: "#f04e23"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "path22",
  className: "cls-2",
  transform: "translate(-13.49 -8.85)",
  d: "M159 25.8v11.92a1 1 0 001 1h5.79a1 1 0 001-1v-15z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path24",
  className: "cls-2",
  transform: "translate(-13.49 -8.85)",
  d: "M195.26 10.15a3.19 3.19 0 013.26 3.09v26.33a3.19 3.19 0 01-3.26 3.09h-38.21a3.19 3.19 0 01-3.26-3.09V13.24a3.19 3.19 0 013.26-3.09h38.21m0-1.3h-38.21a4.49 4.49 0 00-4.56 4.39v26.33a4.49 4.49 0 004.56 4.43h38.21a4.49 4.49 0 004.56-4.39V13.24a4.49 4.49 0 00-4.56-4.39z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "text32",
  transform: "translate(0 29.88)",
  fill: "#003168",
  "aria-label": "MOBIIL",
  fontSize: "33.31px",
  fontFamily: "Aino-Bold,Aino",
  fontWeight: "{700} ",
  letterSpacing: ".01em"
}, /*#__PURE__*/React.createElement("path", {
  id: "path39",
  d: "M2.665 0h4.63v-18.587l1.566 3.764L15.855 0h4.13l6.928-14.856 1.6-3.764V0h4.63v-24.649h-6.096l-9.094 19.32-9.227-19.32H2.665z",
  fill: "#003168"
}), /*#__PURE__*/React.createElement("path", {
  id: "path41",
  d: "M49.254.366c7.228 0 12.591-5.696 12.591-12.724 0-7.061-5.33-12.724-12.591-12.724-7.162 0-12.591 5.663-12.591 12.724 0 7.029 5.43 12.724 12.591 12.724zm-.067-4.396c-4.43 0-7.66-3.831-7.66-8.328 0-4.53 3.197-8.36 7.66-8.36 4.53 0 7.828 3.83 7.828 8.36 0 4.497-3.264 8.328-7.828 8.328z",
  fill: "#003168"
}), /*#__PURE__*/React.createElement("path", {
  id: "path43",
  d: "M76.908 0c5.93 0 9.36-2.998 9.36-7.195 0-3.398-3.064-5.03-4.53-5.13v-.3c1.466 0 4.33-1.398 4.33-5.063 0-3.864-3.43-6.961-8.993-6.961h-10.36V0zm.233-10.493c2.732 0 4.197 1.466 4.197 3.198 0 1.865-1.199 3.464-4.563 3.464h-5.33v-6.662zm-.033-10.326c2.565 0 3.997 1.632 3.997 3.298 0 1.698-1.432 3.197-3.997 3.197h-5.663v-6.495z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path45",
  d: "M96.255 0v-24.649h-4.73V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path47",
  d: "M107.21 0v-24.649h-4.73V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path49",
  d: "M113.44 0h17.088v-3.997H118.17V-24.65h-4.73z"
}));

var SvgMobiilId = function SvgMobiilId(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 186.34 38.17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobiilId, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobiil_id.c0403440.svg";
export { ForwardRef as ReactComponent };